/**
 * snippet from gtag installation instructions
 * @returns {function} the gtag function
 */
export const gtagSnippet = () => {
	window.dataLayer = window.dataLayer || [];
	function gtag() {
		dataLayer.push(arguments);
	}
	return gtag;
};
